import '.i{display:flex;}.ssr-plugin'
import '.n{align-items:center;}.ssr-plugin'
import '.j{justify-content:center;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.bf{background-color:var(--shades-beige-100);}.ssr-plugin'
import '.bg{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.bh{margin-top:2rem;}.ssr-plugin'
import '.b7{margin-bottom:5rem;}.ssr-plugin'
import '.b6{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { ClientOnly, Head } from '@based/sdk'

export const DashboardPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <Head>
        <title>CrowdBuilding - dashboard</title>
      </Head>
      <div className="i n j m bf"
      >
        <DashboardNavBar />
        <div className="bg i m ab bh b7 b6"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%', // 12rem is padding + navbar height
            paddingInline: isMobile ? '1rem' : 0,}}
        >
          {children}
        </div>
      </div>
    </ClientOnly>
  )
}
